import { Users2, Shield, Home as HomeIcon, Dumbbell } from "lucide-react";

const shots = [
  {
    id: "warmup",
    img: "https://customer-assets.emergentagent.com/job_pickle-trainer-v1/artifacts/nhrgkl37_909E78DD-50BC-443C-A0F6-0D3584DA988D.PNG",
    badge: "Warm-Up & Between Matches",
    icon: Users2,
    title: "When the Courts Are Packed",
    text: "Public courts are crowded. Players have nowhere to warm up or train between matches. Pickle Wall turns any free corner into a full warm-up zone in minutes.",
    span: "md:col-span-2",
  },
  {
    id: "separator",
    img: "https://customer-assets.emergentagent.com/job_pickle-trainer-v1/artifacts/gqj8kh6b_IMG_0463.jpeg",
    badge: "Court Separator",
    icon: Shield,
    title: "Keep the Ball in Your Area",
    text: "Use Pickle Wall to divide a court or seal off a training zone. No more chasing balls into other matches.",
    span: "",
  },
  {
    id: "garage",
    img: "https://customer-assets.emergentagent.com/job_pickle-trainer-v1/artifacts/ueobjmxb_IMG_E52AA85C-401B-4EC7-A377-2C85C5397B24.JPEG",
    badge: "Home Setup · Kitchen Lines",
    icon: HomeIcon,
    title: "Your Garage. Your Court.",
    text: "Mount Pickle Wall against the wall and lay down kitchen lines — an instant home training setup.",
    span: "",
  },
  {
    id: "training",
    img: "https://customer-assets.emergentagent.com/job_pickle-trainer-v1/artifacts/tdl4oasr_08200C1B-E5B2-409A-B791-067DB4422F1A.PNG",
    badge: "Solo Reps",
    icon: Dumbbell,
    title: "Train Kitchen Control. Daily.",
    text: "Set up, paddle in hand, ball in the other — and get in as many reps as you want, on your own schedule.",
    span: "md:col-span-2",
  },
];

export default function InTheWild() {
  return (
    <section
      id="in-the-wild"
      className="relative py-24 md:py-36 bg-[#070707] border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-4">
              In The Wild · Real Players · Real Setups
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight text-balance leading-[0.95]">
              Built for the <br />
              <span className="text-[#FF6B00]">Real</span> Game
            </h2>
          </div>
          <p className="lg:col-span-5 text-lg text-white/70 max-w-md">
            Not renders. Not concepts. These are actual Pickle Wall setups —
            from packed public courts to home garages — proving one truth: you
            can train anywhere.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {shots.map((s) => (
            <div
              key={s.id}
              data-testid={`wild-shot-${s.id}`}
              className={`group relative aspect-[4/3] md:aspect-auto md:min-h-[420px] rounded-3xl overflow-hidden border border-white/10 hover:border-[#FF6B00]/40 transition-all ${s.span}`}
            >
              <img
                src={s.img}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-7 md:p-9">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-9 h-9 rounded-lg bg-[#FF6B00] flex items-center justify-center">
                    <s.icon size={16} className="text-black" strokeWidth={2.2} />
                  </div>
                  <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#FF6B00]">
                    {s.badge}
                  </span>
                </div>
                <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-white leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-white/75 text-sm md:text-base leading-relaxed max-w-md">
                  {s.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-center justify-center">
          <a
            href="/shop"
            data-testid="wild-cta"
            className="group inline-flex items-center gap-3 bg-[#FF6B00] hover:bg-[#E66000] text-black font-bold uppercase tracking-wider text-sm px-7 py-4 transition-all hover:orange-glow"
          >
            Build Your Setup
            <span className="font-display">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
